import coverApi from '@/services/CoverApi'
export default {
  namespaced: true,
  state: {
    covers: [],
    paginationData: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'id',
      totalItems: 0,
      rowsPerPageItems: [5]
    },
    companyId: '',
    loading: true
  },
  mutations: {
    setPagination (state, paginationData) {
      state.paginationData = paginationData
    },
    setTimebarredCoversTotalItems (state, totalItems) {
      state.paginationData.totalItems = totalItems
    },
    setTimebarredCovers (state, covers) {
      state.covers = covers
    },
    changeLoadingState (state, loading) {
      state.loading = loading
    },
    setCoversCompanies (state, { companies }) {
      state.covers.forEach(function (cover) {
        cover.seller = companies.find(function (company) {
          return company.id === cover.sellerId
        })

        cover.buyer = companies.find(function (company) {
          return company.id === cover.buyerId
        })
      })
    },
    setCompanyId (state, companyId) {
      state.companyId = companyId
    }
  },
  actions: {
    async getTimebarredCovers (context, payload) {
      let coverStatusLabels = payload.coverStatusLabels
      let companyId = payload.companyId
      let coverId = payload.coverId
      context.commit('changeLoadingState', true)
      let result = await coverApi.fetchCoversbyStatusPerPage(context.state.paginationData.page, context.state.paginationData.rowsPerPage, 'Timebarred', 'quotedAt', null, null, 'quotedAt', 'desc', companyId, coverId)
      if (result) {
        let emptyCompany = {
          id: '',
          name: '',
          identifierType: '',
          identifierValue: ''
        }
        let covers = result.items.map((item) => {
          return {
            id: item.id,
            sellerId: item.sellerId,
            buyerId: item.buyerId,
            issuedAt: item.invoice.issuedAt,
            dueAt: item.invoice.dueAt,
            amount: item.invoice.amount + ' ' + item.invoice.currency.toUpperCase(),
            currency: item.invoice.currency.toUpperCase(),
            status: coverStatusLabels.findIndex(x => x.name === item.status) >= 0 ? coverStatusLabels.find(x => x.name === item.status).label : item.status,
            statusCode: item.status,
            seller: emptyCompany,
            buyer: emptyCompany
          }
        })
        let totalItems = result.totalCount
        context.commit('setTimebarredCovers', covers)
        context.commit('setTimebarredCoversTotalItems', totalItems)
        if (totalItems > 0) {
          let sellerIds = covers.map((item) => { return item.sellerId })
          let buyerIds = covers.map((item) => { return item.buyerId })
          let companyIds = [...new Set(sellerIds.concat(buyerIds))]
          context.dispatch('setCoversCompanies', await coverApi.fetchMappedCompaniesFromId(companyIds))
        }
      }
      context.commit('changeLoadingState', false)
    },
    setPagination (context, paginationData) {
      context.commit('setPagination', paginationData)
    },
    setCoversCompanies (context, companies) {
      context.commit('setCoversCompanies', { companies })
    },
    startLoadCovers (context) {
      context.commit('changeLoadingState', true)
    },
    setCompanyId (context, companyId) {
      context.commit('setCompanyId', companyId)
    },
    getEmptyCovers (context) {
      context.commit('setTimebarredCovers', [])
      context.commit('setTimebarredCoversTotalItems', 0)
      context.commit('changeLoadingState', false)
    }
  }
}
